import "./client.css";

// 🔹 Random rating
const getRandomRating = () => {
  const ratings = [4, 4.5, 5];
  return ratings[Math.floor(Math.random() * ratings.length)];
};

// 🔹 5-star system
const renderStars = (rating) => {
  const rounded = Math.floor(rating);
  const totalStars = 5;

  let stars = "";

  for (let i = 0; i < totalStars; i++) {
    if (i < rounded) {
      stars += "★";
    } else {
      stars += "☆";
    }
  }

  return stars;
};

const reviews = [
  {
    name: "Alexander Pothen (Downtown Dubai)",
    text: "My AC was not cooling properly during peak summer. The technician quickly identified a gas leakage issue and fixed it on the spot.",
  },
  {
    name: "Ram Kanta (Deira, Dubai)",
    text: "I had a plumbing leakage in my kitchen sink. The team arrived on time and replaced the damaged pipe efficiently. No mess, very clean work.",
  },
  {
    name: "Units Holiday (Dubai Marina)",
    text: "My washing machine was making loud noise and not spinning. They diagnosed a motor issue and repaired it quickly. Great experience.",
  },
  {
    name: "John Smith (Jumeirah Village Circle)",
    text: "Electricity kept tripping in my apartment. The electrician found a short circuit in the wiring and fixed it safely.",
  },
  {
    name: "Michael Carter (Business Bay)",
    text: "My refrigerator stopped cooling suddenly. The technician replaced the compressor relay and restored it the same day. Excellent service.",
  },
  {
    name: "Sara Ahmed (Al Barsha)",
    text: "AC water leakage was causing damage to my wall. The team cleaned the drainage pipe and solved the issue completely.",
  },
  {
    name: "David Wilson (Dubai Silicon Oasis)",
    text: "Kitchen sink blockage was causing bad smell and overflow. They cleared the drain professionally and gave maintenance tips.",
  },
  {
    name: "Ali Raza (Bur Dubai)",
    text: "My geyser was not heating water properly. They replaced the thermostat and checked safety settings.",
  },
  {
    name: "Emma Johnson (Palm Jumeirah)",
    text: "The AC was blowing warm air. They cleaned coils, fixed refrigerant levels, and now it's working perfectly again.",
  },
  {
    name: "Hassan Khan (International City, Dubai)",
    text: "Bathroom tap was leaking continuously. The plumber replaced the washer and fixed it within minutes. Fast and efficient.",
  },
];

function Revi() {
  return (
    <div className="reviews_section">

      <h3>WHAT OUR CLIENTS SAY</h3>

      <h1 className="reviews_section_heading">
        <span>Customer</span> Reviews
      </h1>

      <div className="slider">
        <div className="slide_track">

          {[...reviews, ...reviews].map((item, index) => {
            const rating = getRandomRating();

            return (
              <div className="testimonial_card" key={index}>

                <div className="stars">
                  {renderStars(rating)}
                </div>

                <p className="testimonial_text">
                  "{item.text}"
                </p>

                <p className="testimonial_author">
                  — {item.name}
                </p>

              </div>
            );
          })}

        </div>
      </div>

    </div>
  );
}

export default Revi;